import RunScreenerInputContainerFieldsFragment from "components/screener/v2/query/RunScreenerInputContainerFieldsFragment";
import ScreenerIndicatorFieldsFragment from "components/screener/v2/query/ScreenerIndicatorFieldsFragment";
import gql from "graphql-tag";
const RunScreenerInputQuery = gql`
  query RunScreenerInput($objectId: ID!, $language: ISO6391LanguageCode) {
    runScreenerInput(objectId: $objectId, language: $language) {
      objectId
      ...RunScreenerInputContainerFields
      selectedIndicators {
        ...ScreenerIndicatorFields
      }
    }
  }
  ${RunScreenerInputContainerFieldsFragment}
  ${ScreenerIndicatorFieldsFragment}
`;
export default RunScreenerInputQuery;
